import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, Link, useParams } from "react-router-dom";

const Header = () => {
    return (
        <div>
            <nav class="navbar navbar-expand-md bg-dark navbar-dark">
                {/* <a class="navbar-brand" href="/">Home</a> */}

                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="collapsibleNavbar">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <Link class="nav-link" to={`/`}>Home</Link>
                        </li>
                        <li class="nav-item">
                            <Link class="nav-link" to={`/about`}>Abouts Us</Link>
                        </li>
                        <li class="nav-item">
                            <Link class="nav-link" to={`/services`}>Services</Link>
                        </li>
                        <li class="nav-item">
                            <Link class="nav-link" to={`/blog`}>Blog</Link>
                        </li>
                        <li class="nav-item">
                            <Link class="nav-link" to={`/contact-us`}>Contact Us</Link>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    )
}

export default Header